import { products, type ProductId } from '../tokens'
import { cn } from '../utils'

interface NolensMarkProps {
  /** Lado em px. */
  size?: number
  /**
   * Força um produto. Sem isto, usa o produto ativo (`data-product` num
   * antepassado), através das variáveis --product-icon / --node.
   */
  product?: ProductId
  className?: string
  /**
   * Nome acessível. Omitir quando o nome do produto já está escrito ao lado
   * (o símbolo fica decorativo e o leitor de ecrã não o anuncia duas vezes).
   */
  label?: string
}

// O símbolo Nolens: um N de linhas e nós brancos sobre o squircle do
// produto, a terminar no nó teal em baixo à direita.
export function NolensMark({ size = 32, product, className, label }: NolensMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      data-product={product}
      className={cn('shrink-0', className)}
    >
      <rect width="64" height="64" rx="16" fill="rgb(var(--product-icon))" />
      <g stroke="#fff" strokeWidth="4.5" strokeLinecap="round" fill="none">
        <path d="M20 18 V46 M20 18 L44 46 M44 18 V46" />
      </g>
      <g fill="#fff">
        <circle cx="20" cy="18" r="5" />
        <circle cx="44" cy="18" r="5" />
        <circle cx="20" cy="46" r="5" />
      </g>
      <circle cx="44" cy="46" r="6" fill="rgb(var(--node))" stroke="#fff" strokeWidth="3" />
    </svg>
  )
}

interface NolensWordmarkProps {
  product: ProductId
  className?: string
}

// "Nolens" + nome do subproduto no tom claro do produto, como na grelha.
// Só sobre fundo escuro: o tom claro não tem contraste em fundo branco.
export function NolensWordmark({ product, className }: NolensWordmarkProps) {
  const sub = products[product].name.replace(/^Nolens\s+/, '')
  return (
    <span data-product={product} className={cn('inline-flex items-baseline gap-1 leading-none', className)}>
      <span className="font-normal">Nolens</span>
      <span className="font-semibold text-product-label">{sub}</span>
    </span>
  )
}
